var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"launch-select-user"},[_c('CompanyFriend',{attrs:{"show":"","type":1,"show-header":false,"show-company-name":false},on:{"onClose":function($event){_vm.showSelectUserDialog = false},"roleCallback":_vm.onSelectUserDialogConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }